<div class="about text-center" id="about">
  <div class="container">
    <div class="col-12 col-lg-12">
      <div class="d-flex align-items-center justify-content-center p-3">
        <h1 class="fw-bold">{{"about-heading1" | translate}} <span class="fw-bold text-secondary">{{tokenName}}</span> {{"about-heading2" | translate}}</h1>
      </div>
      <p class="font-20 mb-4">{{"about-desc-1" | translate}}</p>
      <!-- <p class="font-20 mb-5">{{"about-desc-2" | translate}}</p> -->
    </div>

    <div class="row align-items-center mt-5 pt-5">
      <div class="col-12 col-lg-6 ">
        <img src="/assets/images/svg-icons/about-img.svg" alt="" class="img-fluid">
      </div>
      <div class="col-12 col-lg-6">
        <h2 class="font-28 fw-bold p-2">{{"about-head_1" | translate}}</h2>
        <p class="font-16">{{"about-para_1" | translate}}</p>
      </div>
    </div>
    <div class="row align-items-center mt-5 pt-5">
      <div class="col-12 col-lg-6 order-2 order-lg-1">
        <h2 class="font-28 fw-bold  p-2">{{"about-head_2" | translate}}</h2>
        <p class="font-16">{{"about-para_2" | translate}}</p>
        <div class="mt-4">
          <p class="font-16 mb-1" translate><span class="fw-bold">{{"total_supply" | translate}} :</span> total_supply_no</p>
          <p class="font-16 mb-1" translate><span class="fw-bold">{{"total_for_sale" | translate}}:</span> total_for_sale_no</p>
          <p class="font-16 mb-1" translate><span class="fw-bold">{{"total_for_stake" | translate}}:</span> total_for_stake_no</p>
          <p class="font-16 mb-1" translate><span class="fw-bold">{{"dex_liquidity" | translate}} :</span> dex_liquidity_no</p>
          <p class="font-16 mb-1" translate><span class="fw-bold">{{"burn_allocation" | translate}} :</span> burn_allocation_no</p>
        </div>
      </div>
      <div class="col-12 col-lg-6 order-1 order-lg-2">
        <img src="/assets/images/svg-icons/about.svg" alt="" class="img-fluid">
      </div>

    </div>
    <div class="row align-items-center mt-5 pt-5">
      <div class="col-12 col-lg-6">
        <img src="/assets/images/svg-icons/about-img.svg" alt="" class="img-fluid">
      </div>
      <div class="col-12 col-lg-6">
        <h2 class="font-28 fw-bold p-2">{{"about-head_3" | translate}}</h2>
        <p class="font-16">{{"about-para_3" | translate}}</p>
      </div>
    </div>
  </div>
</div>
